import { lazy } from "react";

const DMS_Dashboard = lazy(() => import("@/pages/DMS/Dashboard/index"));
const DMS_MyDocuments = lazy(() => import("@/pages/DMS/MyDocuments/index"));
const DMS_Incoming = lazy(() => import("@/pages/DMS/Incoming/index"));
const DMS_Outgoing = lazy(() => import("@/pages/DMS/Outgoing/index"));
const DMS_Archive = lazy(() => import("@/pages/DMS/Archive/index"));
const DMS_Reports = lazy(() => import("@/pages/DMS/Reports/index"));
const DMS_Settings = lazy(() => import("@/pages/DMS/Settings/index"));

export var dmsRoutes = [
    { path: "/dms/dashboard", component: <DMS_Dashboard /> },
    { path: "/dms/mydocuments", component: <DMS_MyDocuments /> },
    { path: "/dms/incoming", component: <DMS_Incoming /> },
    { path: "/dms/outgoing", component: <DMS_Outgoing /> },
    { path: "/dms/archive", component: <DMS_Archive /> },
    { path: "/dms/reports", component: <DMS_Reports /> },
    { path: "/dms/settings", component: <DMS_Settings /> },
];